import { Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";

const RenderParticipantFullName = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={3}
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body1" color="initial">
      {appointment.participantFullName === null
        ? "Termin ist frei"
        : appointment.participantFullName}
    </Typography>
  </Grid>
);

export default RenderParticipantFullName;
